/**
 * 앱 엔트리: GlobalApplication(공통) → PageApplication(라우트 TS).
 */
import { GlobalApplication } from "./app/GlobalApplication";
import { PageApplication } from "./app/PageApplication";
import { controllerRegistry } from "./app/ControllerRegistry";

export class Application {
    boot(): void {
        new GlobalApplication(controllerRegistry).run();
        new PageApplication(controllerRegistry).run();
    }
}
